import { useQuery } from "convex/react";
import type { FunctionReturnType } from "convex/server";
import { api } from "@convex/_generated/api";
import { ApplicationEnum } from "@convex/schema";

export type CurrentUser = NonNullable<
  FunctionReturnType<typeof api.users.currentUserProfile>
>;

export function useCurrentUser(): CurrentUser | null | undefined {
  return useQuery(api.users.currentUserProfile);
}

/**
 * Gestionnaire = user SANS groupe (cf. `estGestionnaire` côté Convex, qui fait
 * foi) : affichage conditionnel seulement.
 */
export function estGestionnaireClient(
  user: CurrentUser | null | undefined,
): boolean {
  return !!user && user.groupId === undefined;
}

/**
 * Les scorecards ne servent qu'à l'entretien structuré : l'organisation doit
 * l'avoir (FairView). Un gestionnaire n'a pas de groupe, ses applications sont
 * donc celles de l'organisation. Affichage seulement, cf.
 * `assertPeutGererScorecards`.
 */
export function aEntretienStructure(
  user: CurrentUser | null | undefined,
): boolean {
  return !!user?.applicationsAutorisees.includes(ApplicationEnum.ENT_STRUCT);
}
